<div class="news-embed" #embedHost></div>

@if (!embedLoaded()) {
  <div class="news-embed-skeleton" aria-hidden="true">
    @for (row of skeletonRows(); track row) {
      <div class="news-embed-skeleton-row"></div>
    }
  </div>
}
